import { createFileRoute } from "@tanstack/react-router";
import { WorkflowComposeView } from "@/components/views/workflow/WorkflowComposeView";

export const Route = createFileRoute("/workflows/compose")({
  component: () => <WorkflowComposeView />,
});
